import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Autocomplete,
  Checkbox,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { get, post } from 'src/services/httpClient.service';


import { authenticationService } from "src/services";
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import CircularProgress from '@mui/material/CircularProgress';




interface ErrorMessages {
  name: string;
  appType: string;
  streamId: string;
  // logo: string;
  // imageUpload: string;
  // landscapeLogo: string;
}

interface Stream {
  id: string;
  name: string;
  url: string;
}

const AddCategory = ({ handleClose, apiURL }) => {
  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [categoryData, setCategoryData] = useState({
    name: '',
    appType: '',
    streamId: '',
    dvrEnabled: false,
    drmEnabled: false,
    transcoderEnabled: false,
    streamTargetsEnabled: false,
    logo: null,
    imageUpload: null,
    landscapeLogo: null,
  });

  /* api Loaders */
  const [loadingStreams, setLoadingStreams] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  
  const [selectedStreams, setSelectedStreams] = useState<Stream[]>([]);
  const [streamIps, setStreamIps] = useState<Stream[]>([]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;


  const [errorMessages, setErrorMessages] = useState<ErrorMessages>({
    name: "",
    appType: "",
    streamId: "",
    // logo: "",
    // imageUpload: "",
    // landscapeLogo: "",
  });

  const [preview, setPreview] = useState({
    logo: null,
    imageUpload: null,
    landscapeLogo: null,
  });


  const APP_TYPES = [
    { label: 'Live', value: 'Live' },
    { label: 'VOD', value: 'VOD' }
  ];


  useEffect(() => {
    fetchServerIps();
  }, []);

  const fetchServerIps = async () => {
    setLoadingStreams(true);
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/vendor-streams/vendor/${vendorId}/findAll`);
      if (Array.isArray(response?.data)) {
        console.log('response',response)

        // show only STREAM type servers
      const filteredStreams = response?.data.filter(
        (stream) => stream.serverType === "STREAM"
      );
        setStreamIps(filteredStreams);
      } else {
        console.error('Invalid data format for stream IPs:', response.data);
      }
    } catch (error) {
      console.error('Error fetching stream IPs:', error);
    } finally {
      setLoadingStreams(false);
    }
  };

  const handleChange = (event, field) => {
    let { value, type, checked } = event.target;

    // ⛔ Prevent leading whitespace for text fields
    if (type !== 'checkbox') {
      value = value.replace(/^\s+/, '');
    }


    setCategoryData((prevData) => ({
      ...prevData,
      [field]: type === 'checkbox' ? checked : value,
    }));
  };

  const validateFile = (file, field) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      setErrorMessages((prev) => ({
        ...prev,
        [field]: `Invalid file type. Only JPG, PNG, and GIF are allowed.`,
      }));
      return false;
    }

    const image = new Image();
    image.src = URL.createObjectURL(file);
    return new Promise((resolve) => {
      image.onload = () => {
        let isValid = false;
        if (
          (field === 'logo' && image.width === 400 && image.height === 400) ||
          (field === 'imageUpload' && image.width === 640 && image.height === 360) ||
          (field === 'landscapeLogo' && image.width === 500 && image.height === 296)
        ) {
          isValid = true;
        } else {
          setErrorMessages((prev) => ({
            ...prev,
            [field]: `Invalid dimensions. Expected ${field === 'logo' ? '400x400' : field === 'imageUpload' ? '640x360' : '500x296'
              }.`,
          }));
        }
        resolve(isValid);
      };
    });
  };

  const validateForm = () => {
    let errors: ErrorMessages = {
      name: "",
      appType: "",
      streamId: "",
      // logo: "",
      // imageUpload: "",
      // landscapeLogo: "",
    };

    if (!categoryData.name.trim()) {
      errors.name = "Category Name is required";
    }
    if (!categoryData.appType.trim()) {
      errors.appType = "Category Type is required";
    }
    if (selectedStreams.length === 0) {
      errors.streamId = "Please select at least one stream";
    }
    /* if (!categoryData.logo) {
      errors.logo = "Logo is required";
    }
    if (!categoryData.imageUpload) {
      errors.imageUpload = "Image is required";
    }
    if (!categoryData.landscapeLogo) {
      errors.landscapeLogo = "Landscape Logo is required";
    } */

    // ⛔️ Instead of merging with prev, directly set new object
    setErrorMessages(errors);

    return Object.values(errors).every((msg) => msg === "");
  };




  const handleFileChange = async (event, field) => {
    const file = event.target.files[0];
    if (file) {
      setErrorMessages((prev) => ({ ...prev, [field]: '' })); // Clear any existing error
      const isValid = await validateFile(file, field);
      if (isValid) {
        setCategoryData((prevData) => ({
          ...prevData,
          [field]: file,
        }));
        setPreview((prevPreview) => ({
          ...prevPreview,
          [field]: URL.createObjectURL(file),
        }));
      }
    }
  };

  /* const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append('name', categoryData.name);
      formData.append('appType', categoryData.appType);
      formData.append('streamId', categoryData.streamId);
      formData.append('vendorId', vendorId);
      formData.append('franchiseId', franchiseId);
      //formData.append('streamId', categoryData.streamId);
      // formData.append('dvrEnabled', categoryData.dvrEnabled);
      // formData.append('drmEnabled', categoryData.drmEnabled);
      // formData.append('transcoderEnabled', categoryData.transcoderEnabled);
      // formData.append('streamTargetsEnabled', categoryData.streamTargetsEnabled);
      if (categoryData.logo) formData.append('logo', categoryData.logo);
      if (categoryData.imageUpload) formData.append('imageUpload', categoryData.imageUpload);
      if (categoryData.landscapeLogo) formData.append('landscapeLogo', categoryData.landscapeLogo);

      const response = await post(`${apiURL}/categories/wowza`, formData);
      
         console.log('response',response)
         if(response.responseCode === "200"){
          showSnackbar('Category added successfully.','success')
         }
        handleClose();

      
    } catch (error) {
      showSnackbar('Error adding category:','error')
      
    }
  }; */

  const handleSubmit = async () => {
    if (!validateForm()) {
      showSnackbar("Please fix validation errors before submitting.", "error");
      return;
    }

    setSubmitting(true);

    const trimmedData = {
      ...categoryData,
      name: categoryData.name.trim(),
      appType: categoryData.appType.trim(),
    };

    try {
      const formData = new FormData();
      formData.append("name", trimmedData.name);
      formData.append("appType", trimmedData.appType);
      //formData.append("streamId", trimmedData.streamId);
      //formData.append("streamIds", selectedStreams.map(stream => stream.id));
      formData.append("vendorId", vendorId);
      formData.append("franchiseId", franchiseId);
      selectedStreams.forEach((stream) => {
        formData.append("streamIds", stream.id);
      });
      //formData.append("streamIds", JSON.stringify(selectedStreams.map((s) => s.id)) );

      // if (trimmedData.logo) formData.append("logo", trimmedData.logo);
      // if (trimmedData.imageUpload) formData.append("imageUpload", trimmedData.imageUpload);
      // if (trimmedData.landscapeLogo) formData.append("landscapeLogo", trimmedData.landscapeLogo);

      // console.log("formData:::", formData);
      // return;
      const response = await post(`${apiURL}/categories/create`, formData);

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        showSnackbar(response?.message, "success");
        handleClose();
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      if (error?.response?.data?.data != undefined && error?.response?.data?.data != "") {
        showSnackbar(error?.response?.data?.data, 'error')
        console.log('check1', error?.response?.data?.data, 'error')
      }else{
        showSnackbar(error?.message,'error')
      }
      


    } finally {
      setSubmitting(false);
    }
  };



  const handleCancel = () => {
    handleClose();
  };


  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>





        <TextField
          id="name"
          label="Category Name"
          variant="outlined"
          size="small"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={categoryData.name}
          onChange={(e) => handleChange(e, "name")}
          error={!!errorMessages.name}
          helperText={errorMessages.name}
        />

        <TextField
          select
          id="appType"
          label="App Type"
          size="small"
          fullWidth
          value={categoryData.appType}
          onChange={(e) => handleChange(e, "appType")}
          error={!!errorMessages.appType}
          helperText={errorMessages.appType}
        >
          {APP_TYPES.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </TextField>



        <Autocomplete
  multiple
  disableCloseOnSelect
  options={streamIps}
  value={selectedStreams}
  loading={loadingStreams}
  limitTags={2}
  size="small"
  isOptionEqualToValue={(option, value) => option.id === value.id}
  getOptionLabel={(option) => option.name}
  onChange={(event, value) => {
    setSelectedStreams(value);
    setErrorMessages((prev) => ({
      ...prev,
      streamId: "",
    }));
  }}
  renderOption={(props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        checked={selected}
        sx={{ mr: 1 }}
      />
      {option.name}
    </li>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Streams"
      placeholder="Select Streams"
      error={!!errorMessages.streamId}
      helperText={errorMessages.streamId}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {loadingStreams && <CircularProgress size={18} />}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
/>

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
          <Button onClick={handleCancel} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSubmit}  disabled={submitting} variant="contained" color="primary">
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AddCategory;
